import { ArrowRight } from "lucide-react";
import { QUESTIONS } from "./content";

const QuestionMark = () => (
  <svg className="ground w-56 md:w-80 h-auto justify-self-center" viewBox="0 0 220 260" aria-hidden="true">
    <g className="turn">
      <circle cx="110" cy="120" r="100" fill="none" className="stroke-mm-gold" strokeWidth="1" strokeDasharray="2 8" />
      <circle cx="110" cy="20" r="4" className="fill-mm-gold" />
      <circle cx="200" cy="150" r="3" className="fill-mm-blue" />
      <circle cx="30" cy="170" r="3" className="fill-mm-red" />
    </g>
    <path className="draw stroke-mm-ink" pathLength="1" d="M62 82 C62 30 160 30 160 82 C160 122 112 122 112 165 L112 190" fill="none" strokeWidth="22" strokeLinecap="square" />
    <rect x="101" y="212" width="22" height="22" className="fill-mm-red" />
  </svg>
);

export const Hero = () => (
  <section id="top" className="bg-mm-paper text-mm-ink py-20 md:py-32" data-testid="hero-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr_auto] gap-12 items-center">
      <p className="mm-lab text-mm-golddark md:self-start">Lettre ouverte · France</p>
      <div className="min-w-0">
        <h1 className="disp mm-h1" data-testid="hero-title">
          <span className="ln"><span>Je vous demande</span></span>
          <span className="ln"><span className="text-mm-red">un plan.</span></span>
        </h1>
        <p className="f1 mm-body mt-6 max-w-md">
          Pas un discours. Pas un rêve. Des chiffres exacts, pas des promesses.
        </p>
        <p className="f1 mm-body mt-2 max-w-md italic" data-testid="hero-author">
          Un Terrien de 77 ans qui continue à poser des questions.
        </p>
        <div className="f2 mt-8 flex flex-wrap gap-4">
          <a href="#signer" data-testid="hero-signer-btn" className="group inline-flex items-center gap-3 bg-mm-red text-white px-6 py-4 font-bold hover:bg-mm-ink transition-colors">
            Signer la lettre <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a href="#lettre" data-testid="hero-lire-btn" className="inline-flex items-center px-6 py-4 font-bold border-2 border-mm-ink hover:bg-mm-ink hover:text-mm-paper transition-colors">
            Lire la lettre
          </a>
        </div>
      </div>
      <QuestionMark />
    </div>
  </section>
);

const Row = ({ hidden }) => QUESTIONS.map((q) => (
  <span key={q + hidden} className="flex gap-10" aria-hidden={hidden || undefined}>
    <span>{q}</span><span className="text-mm-gold">★</span>
  </span>
));

export const QuestionsMarquee = () => (
  <section className="bg-mm-ink text-mm-paper py-6 overflow-hidden" aria-label="Les questions" data-testid="questions-marquee">
    <div className="mq disp text-3xl md:text-5xl gap-10 whitespace-nowrap pr-10">
      <Row hidden={false} />
      <Row hidden />
    </div>
  </section>
);
